"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Rx_1 = require("rxjs/Rx");
var Subject_1 = require("rxjs/Subject");
require("rxjs/add/operator/takeUntil");
var ScrollService = /** @class */ (function () {
    function ScrollService() {
        var _this = this;
        this.ngUnsubscribe = new Subject_1.Subject();
        // set initial value
        this.manageScrollPos();
        // create observable that we can subscribe to from component or directive
        this.scrollObs = Rx_1.Observable.fromEvent(window, 'scroll');
        // initiate subscription to update values
        this.scrollObs.takeUntil(this.ngUnsubscribe)
            .subscribe(function () { return _this.manageScrollPos(); });
        // create observable for changes in screen size
        this.resizeObs = Rx_1.Observable.fromEvent(window, 'resize');
        // initiate subscription to update values
        this.resizeObs.takeUntil(this.ngUnsubscribe)
            .subscribe(function () { return _this.manageScrollPos(); });
    }
    ScrollService.prototype.manageScrollPos = function () {
        // update service property
        this.pos = window.pageYOffset;
    };
    ScrollService.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    ScrollService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [])
    ], ScrollService);
    return ScrollService;
}());
exports.ScrollService = ScrollService;
//# sourceMappingURL=scroll.service.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-animate-on-scroll/dist/src/scroll.service.js
// module id = ./node_modules/ng2-animate-on-scroll/dist/src/scroll.service.js
// module chunks = vendor